import PropTypes from 'prop-types';
import React from 'react';
import { Router } from 'react-router-dom';
import { useSelector } from 'hooks';
import { useTranslation } from 'react-i18next';
import { ErrorBoundary, Layout } from 'views/containers';
import { Redirect, Route, Switch } from 'react-router';
import { isRouteAvailable, privateRoutes, publicRoutes } from 'core/router.config';

const RouterContainer = ({
    history
}) => {

    const { t } = useTranslation();
    const { user } = useSelector('account');

    return (
        <Router history={ history }>
            <ErrorBoundary>
                <Switch>
                    <Redirect exact from="/" to={ t('/login') } />
                    {
                        publicRoutes.map(({ component, path }) => (
                            <Route exact component={ component } key={ path } path={ path } />
                        ))
                    }
                    <Layout>
                        <Switch>
                            {
                                privateRoutes.map(routeObject => {
                                    const { component, path } = routeObject;
                                    if (!isRouteAvailable(routeObject, user)) return null;
                                    return (
                                        <Route exact component={ component } key={ path } path={ path } />
                                    );
                                })
                            }
                            <Redirect from="*" to={ t('/error404') } />
                        </Switch>
                    </Layout>
                </Switch>
            </ErrorBoundary>
        </Router>
    );
};

RouterContainer.propTypes = {
    history: PropTypes.object
};

export default RouterContainer;
